<template>
  <modal @close="$emit('close')">
    <div class="box content">
      <h1 class="title is-4">Legend</h1>

      <h2 class="title is-5">Icons</h2>
      <table>
        <thead>
          <tr>
            <th>Icon</th>
            <th>Key</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getIcon('CollectionLocation').url">
              </figure>
            </td>
            <td>Collection Location</td>
          </tr>

          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getIcon('PickupLocation').url">
              </figure>
            </td>
            <td>Pickup Location</td>
          </tr>

          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getIcon('PickupRequest', {}).url">
              </figure>
            </td>
            <td>Pickup Request (Call in)</td>
          </tr>

          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getIcon('PickupRequest', { isRecaptureBag: true }).url">
              </figure>
            </td>
            <td>Recapture Bag</td>
          </tr>

          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getIcon('PickupRequest', { isStockpile: true }).url">
              </figure>
            </td>
            <td>Stockpile</td>
          </tr>
        </tbody>
      </table>

      <h2 class="title is-5">Call In Color</h2>
      <table>
        <thead>
          <tr>
            <th>Color</th>
            <th>Key</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#56CCF2')">
              </figure>
            </td>
            <td>Created within the last 7 days</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#FF681F')">
              </figure>
            </td>
            <td>Created within 7 and 14 days ago</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#C96323')">
              </figure>
            </td>
            <td>Created within 14 and 21 days ago</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#C62D42')">
              </figure>
            </td>
            <td>Created more than 21 days ago</td>
          </tr>
        </tbody>
      </table>

      <h2 class="title is-5">Paths</h2>
      <table>
        <thead>
          <tr>
            <th>Color</th>
            <th>Key</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#2F80ED')">
              </figure>
            </td>
            <td>Planned Route</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('red')">
              </figure>
            </td>
            <td>In Progress Route</td>
          </tr>
        </tbody>
      </table>

      <h2 class="title is-5">Planned Path Day of Week Color</h2>
      <table>
        <thead>
          <tr>
            <th>Color</th>
            <th>Key</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#8000ff')">
              </figure>
            </td>
            <td>Monday</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#ff8000')">
              </figure>
            </td>
            <td>Tuesday</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#009933')">
              </figure>
            </td>
            <td>Wednesday</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#33ccff')">
              </figure>
            </td>
            <td>Thursday</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#ff00bf')">
              </figure>
            </td>
            <td>Friday</td>
          </tr>
          <tr>
            <td>
              <figure class="image is-32x32">
                <img class="is-32x32" :src="getColorSVG('#000000')">
              </figure>
            </td>
            <td>Weekend</td>
          </tr>
        </tbody>
      </table>
    </div>
  </modal>
</template>

<script>
import Library from 'library'
import * as MapperHelpers from '../MapperHelpers'

export default {
  name: 'MapperLegend',
  
  methods: {
    getIcon: MapperHelpers.getIcon,
    getColorSVG: MapperHelpers.getColorSVG
  },

  components: {
    Modal: Library.Components.Modal
  }
}
</script>
